var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ds-control ds-selectpermissions" },
    [
      _c("div", { staticClass: "left" }, [
        _vm.showRole
          ? _c(
              "div",
              {
                ref: "header",
                staticClass: "header",
                class: [_vm.tabIndex ? "tabIndex1" : "tabIndex0"],
              },
              [
                _c(
                  "span",
                  {
                    on: {
                      click: function ($event) {
                        _vm.tabIndex = 0
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "iconfont icon-icon_user_bm" }),
                    _c("span", [_vm._v("按组织机构选")]),
                  ]
                ),
                _c(
                  "span",
                  {
                    on: {
                      click: function ($event) {
                        _vm.tabIndex = 1
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "iconfont icon-zhuhutiaocha" }),
                    _c("span", [_vm._v("按部门角色选")]),
                  ]
                ),
              ]
            )
          : _vm._e(),
        _c(
          "div",
          {
            ref: "content",
            staticClass: "content",
            style: { height: _vm.contentHeight },
          },
          [
            _vm.inited
              ? [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.tabIndex,
                          expression: "!tabIndex",
                        },
                      ],
                      staticClass: "tabIndex0",
                    },
                    [_c("org-box", { ref: "orgBox" })],
                    1
                  ),
                  _vm.showRole
                    ? _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.tabIndex,
                              expression: "tabIndex",
                            },
                          ],
                          staticClass: "tabIndex1",
                        },
                        [
                          _c("org-box", {
                            ref: "roleOrgBox",
                            attrs: { "is-role": true },
                          }),
                          _c("role-tree", { ref: "roleTree" }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              : _vm._e(),
          ],
          2
        ),
      ]),
      _c("result-list", {
        ref: "resultList",
        attrs: { list: _vm.resultLists },
      }),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.tabIndex,
              expression: "tabIndex",
            },
          ],
          ref: "roleBtn",
          staticClass: "roleBtn",
          style: { right: _vm.rightCss },
          on: { click: _vm.setRoleResultList },
        },
        [
          _c("span", [_vm._v("选")]),
          _c("span", [_vm._v("择")]),
          _c("i", { staticClass: "el-icon-d-arrow-right" }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }